import { JWMImage } from "@components/JWMImage/JWMImage";
import { CMSBlock } from "@jwm/types/CMSBlock";
import { CMSColumnHorizontalAlign } from "@jwm/types/CMSRowProps";
import { mapLinkGroupProps } from "@utils/cms-mapper/mapLinkGroupProps";
import React from "react";

import { trackingHelpersProps } from "../types";

interface ImageBlockProps {
    content: CMSBlock["image"];
    placement?: string;
    trackingHelpers: trackingHelpersProps;
    sectionIndex?: number;
    columnHorizontalAlignment?: CMSColumnHorizontalAlign;
}

export const ImageBlock = ({
    content,
    placement,
    trackingHelpers,
    sectionIndex = 0,
    columnHorizontalAlignment = "Center",
}: ImageBlockProps): JSX.Element => {
    trackingHelpers.position++;
    const imageLink = mapLinkGroupProps(content?.image_link);
    const extension = content?.image?.url?.match(/[^\\]*\.(\w+)$/)?.[1] || "";
    return (
        <JWMImage
            image={content}
            imageLink={imageLink}
            extension={extension}
            placement={placement}
            sectionIndex={sectionIndex}
            horizontalAlignment={columnHorizontalAlignment}
        />
    );
};
